import type { Components } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';

import type { Theme } from '../types';

export const MuiTableHead = {
  styleOverrides: {
    root: {
      [`& .${tableCellClasses.root}`]: {
        backgroundColor: 'transparent',
        color: 'var(--mui-palette-text-secondary)',
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: 1.25,
      },
    },
  },
} satisfies Components<Theme>['MuiTableHead'];
